<template v-slot:activator>
  <v-list-tile 
    :to="item.link"
    @click.stop="('action' in item) ? item.action() : $router.push(item.link)"
    :ripple="true"
    :inactive="item.pages.includes(page)"

    class="no-padding-transition"
    :class="{ 'nav-active': item.pages.includes(page) || item.pages.includes(parentPage), 'align-icons': !navCollapsed, 'subapp': item.subapp }"
    :disabled="item.disabled"
  >
    <v-list-tile-action style="justify-content: center">
      <v-badge v-if="navCollapsed && ('badge' in item) && item.badge > 0" right>
        <span slot="badge">{{ item.badge }}</span>
        <v-icon>{{ item.icon }}</v-icon>
      </v-badge>
      <v-icon v-else>{{ item.icon }}</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      <v-list-tile-title :class="{'subapptitle':item.subapp}">{{ item.title }}</v-list-tile-title>
      <v-list-tile-sub-title class="caption">{{ item.subtitle}}</v-list-tile-sub-title>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
export default {
  name: "NavLink",
  props: ["item", "navCollapsed", "page", "parentPage"]
};
</script>

<style lang="scss">
.nav-active {
  background: rgba(255, 255, 255, 0.15);
}

.align-icons {
  & > a,
  & > div {
    padding-left: 12px !important;
  }
}

.no-padding-transition {
  transition: padding 0ms !important;
  & > a,
  & > div {
    transition: padding 0ms !important;
  }
}
.subapp{
  height:30px!important;

}
.subapp .v-list__tile{
height:30px!important;
}
.subapptitle{
  font-size: 14px;
}
</style>
